import React from 'react';
import cx from 'classnames';
import cssInJS from './css';
// @ts-ignore
const Input = (props: React.InputHTMLAttributes<Record<string, any>>) => (<input {...props} className={cx(customStyles.input, 'custom-input')} />);

const customStyles = cssInJS({
  input: {
    width: '100%',
    margin: 0,
    paddingLeft: 10,
    transition: 'all .15s',
  },
});

export default Input;
